import clsx from 'clsx';
import style from './style.module.css';

type PaymentTypesHeadingProps = {
  isDesktop: boolean;
  title: string;
};

export const PaymentTypesHeading = ({
  isDesktop,
  title,
}: PaymentTypesHeadingProps) => (
  <h2
    className={clsx(
      isDesktop ? 'heading' : 'title',
      style.paymentTypesTitle,
    )}
  >
    {title}
  </h2>
);
